module.exports = __webpack_public_path__ + "img/icon_map_9_c.56fe5845.png";